import { useEffect } from "react";
import SignUp from "../components/login/SignUp";
import { useCookies } from "react-cookie";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";
import { useLoginStatus } from "../hooks/useLoginStatus";
import { path } from "../components/common/Common";

function SignUpScreen() {
    const navigate = useNavigate();
    const isLogin = useLoginStatus();

    useEffect(() => {
        const iamport = document.createElement("script");
        const jquery = document.createElement("script");
        iamport.src = "https://cdn.iamport.kr/js/iamport.payment-1.1.7.js";
        jquery.src = "https://code.jquery.com/jquery-1.12.4.min.js";
        document.head.appendChild(iamport);
        document.head.appendChild(jquery);
        return () => {
            document.head.removeChild(iamport);
            document.head.removeChild(jquery);
        };
    }, []);

    // 로그인 되면 라우팅
    useEffect(() => {
        if (isLogin) {
            navigate(path.ROOT, { replace: true });
        }
    }, [isLogin, navigate]);

    const onClickRegist = () => {
        // const data: PaymentData = {
        //     name: cookies.KMNM,
        //     email: cookies.KMUI,
        // };
        // Upgrade(data);
    };
    return (
        <>
            <Helmet>
                <title>회원가입 - 모두의지도</title>
                <meta name="description" content="간편하게 회원가입하고 더 다양한 모두의지도 서비스를 이용하세요" />
            </Helmet>
            <div>
                <SignUp />
            </div>
        </>
    );
}

export default SignUpScreen;
